import { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';

const tabs = [
  { key: '1', label: 'Transactions', countKey: null },
  { key: '2', label: 'Pending Transactions', countKey: 'pending' },
  { key: '3', label: 'Transaction approvals', countKey: 'createApproval' },
  { key: '4', label: 'Change approvals', countKey: 'updateApproval' },
];

const TabLabel = ({ tab, count, t }) => (
  <>
    <span>{t(tab.label)}</span>
    {count > 0 && (
      <span className='inline-flex min-w-5 items-center justify-center rounded-full bg-[var(--danger)] px-1.5 py-0.5 text-xs font-bold text-white'>
        {count > 99 ? '99+' : count}
      </span>
    )}
  </>
);

export const TransactionsTabs = ({ activeKey, counts, onChange, t }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const activeTab = tabs.find((tab) => tab.key === activeKey) || tabs[0];
  const activeCount = activeTab.countKey ? counts[activeTab.countKey] : 0;

  const changeTab = (key) => {
    onChange(key);
    setMobileOpen(false);
  };

  return (
    <>
      <div className='relative z-20 lg:hidden'>
        <div className='rounded-[var(--radius-md)] bg-[var(--surface-panel-muted)] p-1'>
          <button
            type='button'
            className='flex min-h-12 w-full items-center justify-between gap-3 rounded-[var(--radius-md)] bg-[var(--surface-panel)] px-3 text-left text-sm font-semibold text-[var(--brand-strong)] shadow-sm'
            onClick={() => setMobileOpen((current) => !current)}
            aria-expanded={mobileOpen}
            aria-controls='transactions-mobile-tabs'
          >
            <span className='flex min-w-0 items-center gap-2'>
              <TabLabel tab={activeTab} count={activeCount} t={t} />
            </span>
            <FiChevronDown
              className={`h-5 w-5 shrink-0 text-[var(--text-muted)] transition-transform ${mobileOpen ? 'rotate-180' : ''}`}
              aria-hidden='true'
            />
          </button>

          {mobileOpen && (
            <div
              id='transactions-mobile-tabs'
              className='absolute left-0 right-0 top-full mt-1 grid gap-1 rounded-[var(--radius-md)] bg-[var(--surface-panel-muted)] p-1 shadow-[var(--shadow-popover)]'
            >
              {tabs
                .filter((tab) => tab.key !== activeKey)
                .map((tab) => {
                  const count = tab.countKey ? counts[tab.countKey] : 0;
                  return (
                    <button
                      key={tab.key}
                      type='button'
                      onClick={() => changeTab(tab.key)}
                      className='flex min-h-11 w-full items-center justify-between gap-2 rounded-[var(--radius-md)] px-3 text-left text-sm font-semibold text-[var(--text-secondary)] hover:bg-[var(--surface-panel)] hover:text-[var(--text-primary)]'
                    >
                      <TabLabel tab={tab} count={count} t={t} />
                    </button>
                  );
                })}
            </div>
          )}
        </div>
      </div>

      <div className='app-scrollbar hidden overflow-x-auto lg:block' role='tablist' aria-label={t('Transactions')}>
        <div className='grid min-w-[760px] grid-cols-4 gap-1 rounded-[var(--radius-md)] bg-[var(--surface-panel-muted)] p-1'>
          {tabs.map((tab) => {
            const active = activeKey === tab.key;
            const count = tab.countKey ? counts[tab.countKey] : 0;
            return (
              <button
                key={tab.key}
                type='button'
                role='tab'
                aria-selected={active}
                onClick={() => onChange(tab.key)}
                className={`flex min-h-12 items-center justify-center gap-2 rounded-[var(--radius-md)] px-3 text-sm font-semibold ${
                  active
                    ? 'bg-[var(--surface-panel)] text-[var(--brand-strong)] shadow-sm'
                    : 'text-[var(--text-secondary)] hover:bg-[var(--surface-panel)] hover:text-[var(--text-primary)]'
                }`}
              >
                <TabLabel tab={tab} count={count} t={t} />
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
};
